import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { createUseStyles } from "react-jss";
import jssVariables from "../../../jss_setup";
import { InlineIcon } from "@iconify/react";

const styles = createUseStyles({
  loader: {
    display: "grid",
    gridGap: jssVariables.normal_gap,
    placeItems: "center",
    textAlign: "center",
  },
  loaderIcon: {
    fontSize: "xxx-large",
  },
  label: { color: jssVariables.colors.text.dark },
});
const BarclaysPayment = () => {
  const classes = styles();

  const fData = useSelector((state) => state.BarclaysData);
  const formEl = useRef(null);

  function handleClick() {
    formEl.current.click();
  }

  useEffect(() => {
    if (!_.isEmpty(fData)) {
      handleClick();
    }
  }, [fData]);

  return (
    <React.Fragment>
      <div className={classes.loader}>
        <InlineIcon icon="eos-icons:loading" className={classes.loaderIcon} />
        <h4 className={classes.label}>
          Please wait while we are initiating your payment process.
        </h4>
      </div>

      <form method="post" action={fData.redirect_url} id="form1" name="form1">
        <input type="hidden" name="ACCEPTURL" value={fData.ACCEPTURL} />
        <input type="hidden" name="AMOUNT" value={fData.AMOUNT} />
        <input type="hidden" name="CANCELURL" value={fData.CANCELURL} />
        <input type="hidden" name="CN" value={fData.CN} />
        <input type="hidden" name="CURRENCY" value={fData.CURRENCY} />
        <input type="hidden" name="DECLINEURL" value={fData.DECLINEURL} />
        <input type="hidden" name="EMAIL" value={fData.EMAIL} />
        <input type="hidden" name="EXCEPTIONURL" value={fData.EXCEPTIONURL} />
        <input type="hidden" name="LANGUAGE" value="en" />
        <input type="hidden" name="ORDERID" value={fData.ORDERID} />
        <input type="hidden" name="PSPID" value={fData.PSPID} />
        <input type="hidden" name="SHASIGN" value={fData.SHASIGN} />
        <button
          type="submit"
          value=""
          id="submit2"
          name="submit2"
          ref={formEl}
        />
      </form>
    </React.Fragment>
  );
};

export default BarclaysPayment;
